import { Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ProductsFacade } from '@kion/data-access/data-access-products';
import { SubSink } from 'subsink';
import { interval, Observable } from 'rxjs';
import { debounce } from 'rxjs/operators';
import { LinkRef, Product } from '@kion/data-models';
// tslint:disable-next-line:nx-enforce-module-boundaries
import { CmsConfig } from '../../../../../cms/src/lib/config/cms.config';
import { ActivatedRoute, ActivationStart, NavigationEnd, Router } from '@angular/router';
// tslint:disable-next-line:nx-enforce-module-boundaries
import { ProductUrlService } from '../../../../../cms/src/lib/services/product-url.service';
import {DOCUMENT} from "@angular/common";

@Component({
  selector: 'kion-lr-search-box',
  templateUrl: './search-box.component.html',
  styleUrls: ['./search-box.component.scss']
})
export class SearchBoxComponent implements OnInit, OnDestroy {

  @ViewChild('inputField') input: ElementRef;

  form: FormGroup;

  results$: Observable<Product[]>;
  total$: Observable<number>;

  private subSink: SubSink;

  private window: Window;

  constructor(
    formBuilder: FormBuilder,
    private productsFacade: ProductsFacade,
    private cmsConfig: CmsConfig,
    private router: Router,
    private productUrlService: ProductUrlService,
    private route: ActivatedRoute,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.form = formBuilder.group(
      {
        search: new FormControl(null, [Validators.required, Validators.minLength(1)])
      }
    );
    this.subSink = new SubSink();
    this.window = this.document.defaultView;
  }

  ngOnInit(): void {
    this.document.body.style.overflow = "hidden";
    this.results$ = this.productsFacade.textSearchResults$;
    this.total$ = this.productsFacade.textSearchTotal$;
    this.subSink.sink = this.form.get('search').valueChanges
      .pipe(debounce(() => interval(500)))
      .subscribe(
      value => {
        if (value) {
          this.productsFacade.textSearch(value);
          return;
        }
        this.productsFacade.textSearchReset();
      }
    );
    this.subSink.sink = this.router.events.subscribe(
      events => {
        if (events instanceof NavigationEnd) {
          // @ts-ignore
          const url = this.route.snapshot._routerState.url;
          if (this.route.snapshot.data.pdp && url.indexOf(this.cmsConfig.routes?.productBaseRoute) !== -1) {
            this.window.location.reload();
          }
        }
      }
    )
  }

  ngOnDestroy(): void {
    this.subSink.unsubscribe();
    this.document.body.style.overflow = "auto";
  }

  getProductLink(product: Product): LinkRef {
    return this.productUrlService.generateUrlFromProduct(product);
  }

  clearForm(): void {
    this.form.get('search').patchValue('');
  }

  routeToSearchPage(): void {
    this.router.navigate([this.cmsConfig.routes?.searchBaseRoute], { queryParams: {query: this.form.get('search').value}}).then(() => {
      //TODO: only on search route
      if (this.route.snapshot.data.search) {
        this.window.location.reload();
      }
    })
  }

  checkInput() {
    setTimeout(
      () => {
        console.log(this.input?.nativeElement?.children[0]?.children[0]?.children[1]?.focus())
      },
      500
    )
  }
}
